<template>
  <div class="page">
    <!-- 搜索 -->
    <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small"
      class="query-form" @submit.native.prevent>
      <el-form-item label="ID">
        <el-input v-model="queryForm.id"></el-input>
      </el-form-item>
      <el-form-item label="商品ID">
        <el-input v-model="queryForm.productId"></el-input>
      </el-form-item>
      <el-form-item label="拼团商品名称">
        <el-input v-model="queryForm.productName"></el-input>
      </el-form-item>
      <el-form-item label="拼团商品图片">
        <el-input v-model="queryForm.productPic"></el-input>
      </el-form-item>
      <el-form-item label="拼团商品价格">
        <el-input v-model="queryForm.groupbuyPrice"></el-input>
      </el-form-item>
      <el-form-item label="拼团人数">
        <el-input v-model="queryForm.groupNumber"></el-input>
      </el-form-item>
      <el-form-item label="虚拟参团数量">
        <el-input v-model="queryForm.virtualNumber"></el-input>
      </el-form-item>
      <el-form-item label="开始时间">
        <el-input v-model="queryForm.startTime"></el-input>
      </el-form-item>
      <el-form-item label="束结时间">
        <el-input v-model="queryForm.endTime"></el-input>
      </el-form-item>
        <el-form-item label="单次最大限购数量">
            <el-input  v-model="queryForm.buyMaxLimit"></el-input>
        </el-form-item>
        <el-form-item label="总限购数量">
            <el-input  v-model="queryForm.buyLimit"></el-input>
        </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="getShopProductGroupbuyList">查询</el-button>
        <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
      </el-form-item>
    </el-form>
    <div class="page-content">
      <div class="page-tool-bar">
        <div class="el-btn-group">
          <el-button type="primary" size="small" icon="el-icon-plus" @click="addShopProductGroupbuy">新建</el-button>
          <el-button type="warning" plain size="small" icon="el-icon-edit" :disabled="multipleSelection.length != 1"
            @click="editShopProductGroupbuy(null)">修改</el-button>
          <el-button type="danger" plain size="small" icon="el-icon-delete" :disabled="multipleSelection.length <= 0"
            @click="deleteShopProductGroupbuy(null)">删除</el-button>
        </div>

        <div class="icon-group">
          <el-upload v-if="this.isImportDate" class="upload-demo" action="#" :http-request="upload"
            :show-file-list="true">
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
          </el-upload>
          <span title="搜索" class="icon-box" @click="search">
            <Icon color="#606266">
              <Search />
            </Icon>
          </span>
          <span title="下载模板" class="icon-box" @click="importTemplate">
            <Icon color="#606266">
              <ArrowDown />
            </Icon>
          </span>
          <span class="icon-box" title="导入数据" @click="isImport">
            <Icon color="#606266">
              <ArrowExportUp24Regular />
            </Icon>
          </span>
          <span title="导出数据" class="icon-box" @click="exportShopProductGroupbuyList">
            <Icon color="#606266">
              <ArrowDownload24Regular />
            </Icon>
          </span>
          <span class="icon-box" @click="refreshShopProductGroupbuyList">
            <Icon color="#606266">
              <Refresh />
            </Icon>
          </span>
        </div>
      </div>
      <!-- 列表数据 -->
      <el-table :data="shopProductGroupbuyList" row-key="id" border height="100%" :header-row-style="{ height: '10px' }"
        :header-cell-style="{ padding: '10px' }" :row-style="{ height: '9px' }" :cell-style="{ padding: '9px' }"
        @selection-change="handleSelectionChange" size="small">
        <el-table-column align="center" type="selection" width="60"> </el-table-column>
        <!-- <el-table-column :show-overflow-tooltip="true" align="center" prop="id" label="ID" width="180"> </el-table-column>
        <el-table-column :show-overflow-tooltip="true" align="center" prop="productId" label="商品ID" width="180">
        </el-table-column> -->
        <el-table-column :show-overflow-tooltip="true" align="center" prop="productName" label="拼团商品名称" width="180">
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" align="center" prop="productPic" label="拼团商品图片" width="180">
          <template slot-scope="scope">
            <div v-if='scope.row.productPic'>
              <el-image @click='updateSrcList(scope.row.productPic)' style="width: 60px; height: 60px"
                :src="scope.row.productPic" :preview-src-list="srcList"> </el-image>
            </div>
            <div v-else>--</div>
          </template>
        </el-table-column>
<!--          <el-table-column-->
<!--              :show-overflow-tooltip="true"-->
<!--              align="center"-->
<!--              prop="productAlbum"-->
<!--              label="产品相册"-->
<!--              width="180"-->
<!--          > </el-table-column>-->
        <el-table-column :show-overflow-tooltip="true" align="center" prop="groupbuyPrice" label="拼团商品价格" width="180">
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" align="center" prop="groupNumber" label="拼团人数" width="180">
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" align="center" prop="virtualNumber" label="虚拟参团数量" width="180">
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" align="center" prop="startTime" label="开始时间" width="180">
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" align="center" prop="endTime" label="束结时间" width="180">
        </el-table-column>
          <el-table-column
              :show-overflow-tooltip="true"
              align="center"
              prop="buyMaxLimit"
              label="单次最大限购数量"
              width="180"
          > </el-table-column>
        <el-table-column :show-overflow-tooltip="true" align="center" prop="buyLimit" label="总限购数量" width="180">
        </el-table-column>
        <el-table-column fixed="right" align="center" label="操作" width="300">
          <template slot-scope="scop">
            <div class="operation">
              <div @click="checkShopProductGroupbuy(scop.row.id)">
                <Icon size="16">
                  <Eye24Regular />
                </Icon>
                <span class="operation-label">查看</span>
              </div>
              <div @click="editShopProductGroupbuy(scop.row.id)">
                <Icon size="16">
                  <Edit24Regular />
                </Icon>
                <span class="operation-label">修改</span>
              </div>
              <div @click="deleteShopProductGroupbuy(scop.row.id)">
                <Icon size="16" style="color: red">
                  <Delete24Regular />
                </Icon>
                <span class="operation-label" style="color: red">删除</span>
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-box">
        <el-pagination @size-change="sizeChange" @current-change="currentChange" :current-page.sync="currentPage"
          :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="totalNum" background :pager-count="7">
        </el-pagination>
      </div>
      <!-- 新增/查看/修改信息 -->
      <el-dialog :title="shopProductGroupbuyStates[shopProductGroupbuyState]" :visible.sync="showDialog" width="60%"
        @close="closeDialog">
        <div>
          <el-tabs :before-leave="next" style="height: auto;" tab-position="left" v-model='first'>
            <el-tab-pane label="选择商品" name="first">
              <el-form
                :model="shopProductGroupbuy"
                ref="shopProductGroupbuyForm1"
                :rules="rules0"
                label-width="150px"
                size="small"
              >
                <el-form-item
                  label="拼团商品图片"
                  prop="productPic"
                >
                  <GridSelectLi :disabled="shopProductGroupbuyState == 'check'" style="width: 186px" title="选择商品" labelName="productPic"
                    labelValue="id" :value="shopProductGroupbuy.productId" :limit="1" size="small" placeholder="请选择商品"
                    @getValue="getSeachValuebrandId" @getPrice="getPrice" :columns="PRODUCT_code" :searchs="PRODUCT_search" dataListUrl="/shop/product/findList" entityBeanName="shopProduct"
                    queryEntityUrl="/shop/product/get">
                  </GridSelectLi>
                </el-form-item>
                  <el-form-item
                      label="产品相册"
                      prop="productPic"
                      v-if="shopProductGroupbuy.productAlbum"
                  >
                      <div style="display: flex;flex-wrap: wrap">
                          <img v-for="(item,index) in srcProductList" style="margin-right:10px;margin-bottom: 10px" :src="item" class="avatar" size="small" />
                      </div>
                  </el-form-item>
              </el-form>
            </el-tab-pane>
            <el-tab-pane label="基本信息" name="two">
              <el-form
                :model="shopProductGroupbuy"
                ref="shopProductGroupbuyForm"
                :rules="rules1"
                label-width="150px"
                size="small"
              >
                <el-form-item
                  label="拼团商品图片"
                  prop="productPic"
                >
                  <el-upload :action="action" :headers="header"
                    :disabled="shopProductGroupbuyState == 'check'" class="avatar-uploader" :show-file-list="false"
                    :http-request="uploadImage">
                    <img v-if="shopProductGroupbuy.productPic" :src="shopProductGroupbuy.productPic" class="avatar" size="small" />
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  </el-upload>
                </el-form-item>
<!--                  <el-form-item-->
<!--                      label="产品相册"-->
<!--                      prop="productAlbum"-->
<!--                  >-->
<!--                      <el-input-->
<!--                          size="small"-->
<!--                          v-model="shopProductGroupbuy.productAlbum"-->
<!--                          :disabled="shopProductGroupbuyState == 'check'"-->
<!--                          style="width: 400px;"-->
<!--                      ></el-input>-->
<!--                  </el-form-item>-->
                  <el-form-item
                      label="产品相册"
                      prop="productPic"
                      v-if="shopProductGroupbuy.productAlbum"
                  >
                      <div style="display: flex;flex-wrap: wrap">
                          <img v-for="item in srcProductList" style="margin-right:10px;margin-bottom: 10px" :src="item" class="avatar" size="small" />
                      </div>
                  </el-form-item>
                <el-form-item
                  label="拼团商品名称"
                  prop="productName"
                >
                  <el-input
                    size="small"
                    v-model="shopProductGroupbuy.productName"
                    :disabled="shopProductGroupbuyState == 'check' || shopProductGroupbuy.productName == ''"
                    style="width: 400px;"
                  ></el-input>
                </el-form-item>
                <el-form-item
                  label="拼团时间"
                  prop="startTime"
                  >
                  <el-date-picker
                    :disabled="shopProductGroupbuyState == 'check'"
                    v-model="value"
                    type="datetimerange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
                  </el-date-picker>
                </el-form-item>
                <el-form-item
                  label="拼团商品价格"
                  prop="groupbuyPrice"
                >
                  <el-input
                    size="small"
                    v-model="shopProductGroupbuy.groupbuyPrice"
                    style="width: 400px;"
                    :disabled="shopProductGroupbuyState == 'check'"
                    placeholder="请输入拼团商品价格"
                  ></el-input>
                  <div class="sub-title">商品原价{{productPrice}}元</div>
                </el-form-item>
                <el-form-item
                  label="拼团人数"
                  prop="number"
                >
                  <el-input
                    size="small"
                    v-model="shopProductGroupbuy.groupNumber"
                    :disabled="shopProductGroupbuyState == 'check'"
                    style="width: 400px;"
                    placeholder="请输入拼团人数"
                  ></el-input>
                  <div class="sub-title">单次拼团需要参与的用户数</div>
                </el-form-item>
                <el-form-item
                  label="虚拟成团数量"
                  prop="virtualNumber"
                >
                  <el-input
                    size="small"
                    v-model="shopProductGroupbuy.virtualNumber"
                    :disabled="shopProductGroupbuyState == 'check'"
                    style="width: 400px;"
                    placeholder="请输入虚拟拼团人数"
                  ></el-input>
                  <div class="sub-title">设置虚拟成团的补齐人数，如：5人团设置补齐2人，当团队成员大于等于3人时，拼团结束时自动补齐剩余最多2个位置，不开启虚拟成团请设置为0</div>
                </el-form-item>
                  <el-form-item
                      label="单次最大限购数量"
                      prop="buyMaxLimit"
                  >
                      <el-input
                          size="small"
                          v-model="shopProductGroupbuy.buyMaxLimit"
                          :disabled="shopProductGroupbuyState == 'check'"
                          style="width: 400px;"
                      ></el-input>
                  </el-form-item>
                <el-form-item
                  label="总限购数量"
                  prop="buyLimit"
                >
                  <el-input
                    size="small"
                    v-model="shopProductGroupbuy.buyLimit"
                    :disabled="shopProductGroupbuyState == 'check'"
                    style="width: 400px;"
                  ></el-input>
                </el-form-item>
              </el-form>
            </el-tab-pane>
          </el-tabs>
        </div>

        <div slot="footer" class="flex justify-end">
          <el-button @click="closeDialog">关闭</el-button>
          <el-button type="primary" @click="submitForm" v-if="shopProductGroupbuyState != 'check'">确定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun, upload } from '@/utils/request.js';
import GridSelectLi from '@/components/shop/selectProduct.vue';
// import GridSelectLi from '@/components/gridselect/gidselect.vue';
import { UPLOAD_PATH, UPLOAD_API } from '@/utils/constant.js';
import { PRODUCT, PRODUCT_SEARCH } from '@/utils/constant.js';
export default {
  components: {
    Edit24Regular,
    Delete24Regular,
    Eye24Regular,
    GridDots,
    Refresh,
    Printer,
    ArrowUp,
    ArrowDown,
    ArrowDownload24Regular,
    ArrowExportUp24Regular,
    Search,
    GridSelectLi
  },
  watch: {
    checkState(val) {
      if (val == 'check') {
        this.resetShopProductGroupbuyList();
        this.getShopProductGroupbuyList(this.queryForm);
        this.$emit('resetCheckState');
      } else if (val == 'reset') {
        this.resetShopProductGroupbuyList();
        this.getShopProductGroupbuyList();
        this.$emit('resetCheckState');
      }
    },
      value:{
          handler(newvalue){
              if(newvalue == null){
                  this.shopProductGroupbuy.startTime = ""
                  this.shopProductGroupbuy.endTime = ""
              }else{
                  console.log(new Date())
                  let date = new Date(newvalue[0]);
                  this.shopProductGroupbuy.startTime = date.getFullYear() + "-" + this.pad(date.getMonth() + 1) + "-" + this.pad(date.getDate()) + " " + this.pad(date.getHours()) + ":" + this.pad(date.getMinutes()) + ":" + this.pad(date.getSeconds())
                  date = new Date(newvalue[1])
                  this.shopProductGroupbuy.endTime = date.getFullYear() + "-" + this.pad(date.getMonth() + 1) + "-" + this.pad(date.getDate()) + " " + this.pad(date.getHours()) + ":" + this.pad(date.getMinutes()) + ":" + this.pad(date.getSeconds())
                  console.log(this.shopProductGroupbuy)
              }
          },
          deep:true
      }
  },
  data() {
    let validateAGreaterThanB = (rule, value, callback)=>{
      console.log(rule, value, callback)
      if(value == 0){
        return callback(new Error('拼团价格不能为零'));
      }
      if (value >= this.productPrice) {
        callback(new Error('拼团价格必须小于售卖价格'));
      } else {
        callback();
      }
    };
    return {
      PRODUCT_code: PRODUCT,
      PRODUCT_search: PRODUCT_SEARCH,
      first:'first',
      active: 0,
      productPrice:0,
      queryForm: {
        id: '', //ID
        productId: '', //商品ID
        productName: '', //团购商品名称
        productPic: '', //图片
        productAlbum: '', //产品相册
          groupbuyPrice: '', //拼团价格
          groupNumber: '', //拼团人数
        virtualNumber: '', //虚拟参团数量
        startTime: '', //开始时间
        endTime: '', //束结时间
          buyMaxLimit: '', //单次最大限购数量
        buyLimit: '', //限购数量
      },
      loading: false,
      showDialog: false,
      isImportDate: false,
      isSearch: false,
      pageSize: 10,
      currentPage: 1,
      totalNum: 0,
      currentUserId: '',
      shopProductGroupbuyState: 'add',
      shopProductGroupbuyStates: {
        add: '新建拼团商品',
        check: '查看拼团商品',
        edit: '修改拼团商品'
      },
      srcList: [''],//大图预览
      multipleSelection: [],
      shopProductGroupbuyList: [],
      shopProductGroupbuy: {
        id: '', //ID
        productId: '', //商品ID
        productName: '', //团购商品名称
        productPic: '', //图片
          productAlbum: '', //产品相册
          groupbuyPrice: '', //拼团价格
          groupNumber: '2', //拼团人数
        virtualNumber: '0', //虚拟参团数量
        startTime: '', //开始时间
        endTime: '', //束结时间
          buyMaxLimit: 1, //单次最大限购数量
        buyLimit: 1, //限购数量
      },
      btnLoading: false,

      value:[],
      action: UPLOAD_API + UPLOAD_PATH,
      header: {
        token: localStorage.getItem('token')
      },
        srcProductList:[],
      rules0: {
        productPic: [{ required: true, message: '图片不能为空', trigger: 'change' }],
      },

      rules1: {
        id: [{ required: true, message: '选择商品不能为空', trigger: 'blur' }],
        productId: [{ required: true, message: '商品ID不能为空', trigger: 'blur' }],
        productName: [{ required: true, message: '团购商品名称不能为空', trigger: 'blur' }],
        productPic: [{ required: true, message: '图片不能为空', trigger: 'change' }],
          productAlbum: [{ required: true, message: '产品相册不能为空', trigger: 'blur' }],
        // price: [{ required: true, message: '拼团价格不能为空', trigger: 'blur' }],
          groupbuyPrice: [{ validator: validateAGreaterThanB, trigger: 'blur' }],
          groupNumber: [{ required: true, message: '拼团人数不能为空', trigger: 'blur' }],
        virtualNumber: [{ required: true, message: '虚拟参团数量不能为空', trigger: 'blur' }],
        startTime: [{ required: true, message: '时间不能为空', trigger: 'blur' }],
        endTime: [{ required: true, message: '时间不能为空', trigger: 'blur' }],
          buyMaxLimit: [{ required: true, message: '单次最大限购数量不能为空', trigger: 'blur' }],
        buyLimit: [{ required: true, message: '限购数量不能为空', trigger: 'blur' }]
      }
    };
  },
  created() {
    this.getShopProductGroupbuyList();
  },
  methods: {
    getPrice(price){
      console.log(price)
      this.productPrice = price
    },
    //上传缩略图
    uploadImage(params) {
      console.log("?")
      const file = params.file;
      let types = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
      if (!types.includes(file.type)) {
        this.$message.error('图片类型错误!');
      }
      const formData = new FormData();
      formData.append('file', file);
      upload(UPLOAD_PATH, formData).then((res) => {
        if (res.success) {
          this.shopProductGroupbuy.productPic = res.url;
        }
      });
    },
    // 大图预览
    updateSrcList(src) {
      this.srcList[0] = src
    },
    pad(num) {  
      return num < 10 ? '0' + num : num;  
    },
    next(event){
      console.log(event)
      // return false
      let bool = true
      this.$refs.shopProductGroupbuyForm1.validate((valid) => {  
        if (valid) {
          // 表单验证通过，执行你的逻辑代码
        } else {
          // 表单验证失败，显示错误信息或执行其他操作 
          bool = false
        }
        console.log(this.shopProductGroupbuy)
      })
      return bool
    },
    // 搜索商品
    getSeachValuebrandId(value){
      console.log("?????")
      console.log(value)
      this.shopProductGroupbuy.productId = value.id
      this.shopProductGroupbuy.productName = value.productName
      this.shopProductGroupbuy.productPic = value.productPic
      this.productPrice = value.shopPrice
      this.shopProductGroupbuy.productAlbum = value.productAlbum
      this.srcProductList = value.productAlbum.split('|')
      console.log(this.shopProductGroupbuy)
    },
    search() {
      this.isSearch = !this.isSearch;
    },
    resetShopProductGroupbuyList() {
      this.pageSize = 10;
      this.currentPage = 1;
      this.shopProductGroupbuyList = [];
    },
    resetDialog() {
      this.shopProductGroupbuyState = 'add';
      this.showDialog = false;
        this.queryForm = {
            id: '', //ID
            productId: '', //商品ID
            productName: '', //拼团商品名称
            productPic: '', //拼团商品图片
            productAlbum: '', //产品相册
            groupbuyPrice: '', //拼团商品价格
            groupNumber: '', //拼团人数
            virtualNumber: '', //虚拟参团数量
            startTime: '', //开始时间
            endTime: '', //束结时间
            buyMaxLimit: '', //单次最大限购数量
            buyLimit: '', //总限购数量
        };
      this.getShopProductGroupbuyList();
    },
    closeDialog() {
      this.active = 0
      this.showDialog = false
        this.shopProductGroupbuy = {
            id: '', //ID
            productId: '', //商品ID
            productName: '', //拼团商品名称
            productPic: '', //拼团商品图片
            productAlbum: '', //产品相册
            groupbuyPrice: '', //拼团商品价格
            groupNumber: '', //拼团人数
            virtualNumber: '', //虚拟参团数量
            startTime: '', //开始时间
            endTime: '', //束结时间
            buyMaxLimit: 1, //单次最大限购数量
            buyLimit: 1, //总限购数量
        };
      this.value = []
        this.srcProductList = []
      this.first = 'first'
    },
    submitForm() {
      console.log(this.shopProductGroupbuy)
      if (this.shopProductGroupbuyState == 'add') {
        this.$refs.shopProductGroupbuyForm.validate((valid) => {
          if (valid) {
            console.log('submit');
            post(`/shop/productgroupbuy/add`, { ...this.shopProductGroupbuy }).then((res) => {
              if (res.success) {
                this.$message({
                  message: res.msg,
                  type: 'success',
                  duration: 2000,
                });
                this.resetShopProductGroupbuyList();
                this.resetDialog();
              } else {
                this.$message({
                  message: res.msg,
                  type: 'error',
                  duration: 2000
                });
              }
            });
          }
        });
      } else if (this.shopProductGroupbuyState == 'edit') {
        this.$refs.shopProductGroupbuyForm.validate((valid) => {
          if (valid) {
            console.log('submit');
            delete this.shopProductGroupbuy.product;
            post(`/shop/productgroupbuy/edit`, { ...this.shopProductGroupbuy }).then((res) => {
              if (res.success) {
                this.$message({
                  message: res.msg,
                  type: 'success',
                  duration: 2000
                });
                this.resetShopProductGroupbuyList();
                this.resetDialog();
              } else {
                this.$message({
                  message: res.msg,
                  type: 'error',
                  duration: 2000
                });
              }
            });
          }
        });
      }
    },
    addShopProductGroupbuy() {
      this.showDialog = true;
      this.shopProductGroupbuyState = 'add';
    },
    checkShopProductGroupbuy(shopProductGroupbuyId) {
      console.log(shopProductGroupbuyId);
      this.currentShopProductGroupbuyId = shopProductGroupbuyId;

      this.getShopProductGroupbuyById();
      this.showDialog = true;
      this.shopProductGroupbuyState = 'check';
    },
    editShopProductGroupbuy(shopProductGroupbuyId) {
      console.log('shopProductGroupbuy', shopProductGroupbuyId);
      if (shopProductGroupbuyId) {
        this.currentShopProductGroupbuyId = shopProductGroupbuyId;
        this.getShopProductGroupbuyById();
      } else {
        this.shopProductGroupbuy = { ...this.shopProductGroupbuy, ...this.multipleSelection[0] };
      }

      this.showDialog = true;
      this.shopProductGroupbuyState = 'edit';
    },
    deleteShopProductGroupbuy(shopProductGroupbuyId) {
      let ids = '';
      if (shopProductGroupbuyId) {
        ids = shopProductGroupbuyId;
      } else {
        ids = this.multipleSelection.map((shopProductGroupbuy) => shopProductGroupbuy.id).join(',');
      }
      console.log({ ids });
      this.$confirm('确定删除所选项吗？', '提示', {
        type: 'warning'
      })
        .then(() => {
          deleteFun(`/shop/productgroupbuy/delete`, { ids }).then((res) => {
            if (res.success) {
              this.$message({
                message: res.msg,
                type: 'success',
                duration: 2000
              });
              this.resetShopProductGroupbuyList();
              this.getShopProductGroupbuyList();
            } else {
              this.$message({
                message: res.msg,
                type: 'error',
                duration: 2000
              });
            }
          });
        })
        .catch(() => { });
    },
    refreshShopProductGroupbuyList() {
      this.resetShopProductGroupbuyList();
      this.getShopProductGroupbuyList();
    },
    getShopProductGroupbuyList(query = {}) {
      this.loading = true;
      get(`/shop/productgroupbuy/findList`, { ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
        this.loading = false;
        if (res.success) {
          this.shopProductGroupbuyList = res.page.list;
          this.totalNum = res.page.total;
        } else {
          this.$message({
            message: res.msg,
            type: 'error',
            duration: 2000
          });
        }
      });
    },
    getShopProductGroupbuyById() {
      get(`/shop/productgroupbuy/get`, { id: this.currentShopProductGroupbuyId }).then((res) => {
        if (res.success) {
          this.shopProductGroupbuy = { ...this.shopProductGroupbuy, ...res.shopProductGroupbuy };
          this.value = [this.shopProductGroupbuy.startTime,this.shopProductGroupbuy.endTime]
            this.srcProductList = this.shopProductGroupbuy.productAlbum.split("|")
        } else {
          this.$message({
            message: res.msg,
            type: 'error',
            duration: 2000
          });
        }
      });
    },
    /**
     * 导出信息
     */
    exportShopProductGroupbuyList() {
      //this.btnLoading = true;
      exprotExcel(`/shop/productgroupbuy/export`, { ...this.queryForm });
    },
    /**
     * 导出模板
     */
    importTemplate() {
      this.btnLoading = true;
      importTemplate(`/shop/productgroupbuy/importTemplate`, this.btnLoading);
    },
    /**
     * 导入数据
     */
    isImport() {
      this.isImportDate = !this.isImportDate;
    },
    upload(params) {
      const file = params.file;
      const formData = new FormData();
      formData.append('file', file);
      console.log({ formData });
      importDate(`/shop/productgroupbuy/importData`, formData);
      this.refreshShopProductGroupbuyList();
    },
    handleSelectionChange(value) {
      console.log(value);
      this.multipleSelection = value;
    },
    currentChange(page) {
      this.currentPage = page;
      this.getShopProductGroupbuyList();
    },
    sizeChange(size) {
      this.pageSize = size;
      this.getShopProductGroupbuyList();
    }
  }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
  border-bottom: 1px solid #eee;
  padding: 15px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  button {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
::v-deep .el-upload--text {
  width: 70px;
  height: 70px;
  border: 1px solid darkgray;
  // border: none;
  // border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar {
  width: 70px;
  height: 70px;
  display: block;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 70px;
  height: 70px;
  line-height: 70px;
  text-align: center;
}
.sub-title{
  font-size: 12px;
  color: darkgray;
}

.operation {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #409eff;
  font-size: 12px;

  &>div {
    display: flex;
    align-items: center;
    padding: 0 5px;
    cursor: pointer;
  }

  .operation-label {
    margin-left: 3px;
  }
}
</style>